import FieldDropdown from "../dropdown/dropdown";
import FieldConfig from "../../proto/field-config";
import Department from "../../../model2/department/department";
import SessionCustomField from "../../../model2/custom-field/session-custom-field";
import {FieldType} from "../../field-type";
import FieldDepartment_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import CustomFieldsV1 from "../../../gd/const/fields/custom-fields-v1";
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import FieldDepartment_PopoverMenuMore from "./components/popover/popover-menu-more"
import FieldDepartment_TListGroupHeader1 from "./render/list-group-header-1"
import FieldDepartment_TListGroupHeader2 from "./render/list-group-header-2"

export default class FieldDepartment extends FieldDropdown {

    constructor(config: FieldConfig) {

        super(config);

        this.typeInteger            = CustomFieldsV1.type.DEPARTMENT
        this.typeGroup              = GROUP_MISC
        this.typeLabel              = "Department"
        this.icon                   = 'i5-departments'
        this.isSearchable           = true
        this.noValueOption          = false
        this.showMenuMore           = false

        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','No departments')

        if (!config.options || config.options.length < 1) {
            // In shared view we don't have all users gd.users ... so need filter
            this.options = []

            // why not to options ?
            gd.session.departments.models.map((d:Department)=> {
                if (d.id) {
                    this.options!.push({
                        value: d.id,
                        label: d.name,
                        icon: "i5-departments"
                    })
                }
            })
        }

        this.classes = _.assign(this.classes, {
            PopoverMenu                 : 'min-w-200',
            PopoverMenuScrollContainer  : 'max-h-300',
        })

        this.components.PopoverMenuMore             = FieldDepartment_PopoverMenuMore

        this.renderComponents.managementFormCFV1    = FieldDepartment_ManagementFormCFV1

        this.renderComponents.tlistGroupHeader1     = FieldDepartment_TListGroupHeader1
        this.renderComponents.tlistGroupHeader2     = FieldDepartment_TListGroupHeader2
    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldDepartment({
            fieldId         : customFieldV1.id,
            label           : customFieldV1.name,
            type            : FieldType.DEPARTMENT,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    getGroupObject(value: any) {
        const found = this._getOption(value)

        return {
            id      : found ? found.value : value,
            value   : found ? found.value : value,
            label   : found ? found.label : value,
            name    : _.get(found, 'label', 'Not defined'),
        }
    }
}
